import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import IRole from '../../../_interfaces/IRole';
import { SessionService } from '../../../_services/session/session.service';
import { RolesService } from '../../../_services/roles/roles.service';
import { BaseComponent } from '../../../components/base/base.component';
import { AdminTableActionsComponent } from '../../admin-ui/admin-table-actions/admin-table-actions.component';
import { AdminListToolbarComponent } from '../../admin-ui/admin-list-toolbar/admin-list-toolbar.component';
import { AdminStatePanelComponent } from '../../admin-ui/admin-state-panel/admin-state-panel.component';

@Component({
  standalone: true,
  selector: 'app-table-roles',
  templateUrl: './table-roles.component.html',
  styleUrls: ['./table-roles.component.scss'],
  imports: [
    CommonModule,
    TableModule,
    TranslatePipe,
    ButtonModule,
    AdminTableActionsComponent,
    AdminListToolbarComponent,
    AdminStatePanelComponent,
  ],
})
export class TableRolesComponent extends BaseComponent implements OnInit {
  public roles: IRole[] = [];
  public filteredRoles: IRole[] = [];
  public searchValue = '';

  isLockedAdminRole(role: IRole): boolean {
    const normalizedName = `${role?.name || ''}`.trim().toLowerCase();
    return normalizedName === 'admin' || normalizedName === 'administrador';
  }

  constructor(
    public readonly confirmService: ConfirmationService,
    public readonly rolesService: RolesService,
    public readonly messageService: MessageService,
    public readonly translate: TranslateService,
    public readonly session: SessionService,
    public readonly router: Router,
  ) {
    super(session);
  }

  onSearch(value: string): void {
    this.searchValue = value;
    const query = value.trim().toLowerCase();

    if (!query) {
      this.filteredRoles = [...this.roles];
      return;
    }

    this.filteredRoles = this.roles.filter((role) =>
      (role.name || '').toLowerCase().includes(query),
    );
  }

  load(): void {
    this.rolesService.getByCustomer(this.customers_id).subscribe({
      next: (roles: IRole[]) => {
        this.roles = roles;
        this.onSearch(this.searchValue);
      },
      error: () => {
        this.roles = [];
        this.filteredRoles = [];
      },
    });
  }

  confirmDelete(role: IRole): void {
    if (!role.id || this.isLockedAdminRole(role)) {
      return;
    }

    this.confirmService.confirm({
      header: this.translate.instant('ADMIN.ROLES.CONFIRM.DELETE.TITLE', {
        role: role.name,
      }),
      message: this.translate.instant('ADMIN.ROLES.CONFIRM.DELETE.TEXT', {
        role: role.name,
      }),
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.delete(role),
    });
  }

  private delete(role: IRole): void {
    this.rolesService.delete(this.customers_id, role.id).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('MESSAGES.ROLES.DELETE.SUMMARY'),
          detail: this.translate.instant('MESSAGES.ROLES.DELETE.DETAIL', {
            role: role.name,
          }),
        });
        this.load();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('MESSAGES.COMMON.500.SUMMARY'),
          detail: this.translate.instant('MESSAGES.COMMON.500.DETAIL'),
        });
      },
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.load();
  }
}
